import { useContext, useEffect } from 'react';
import './PageStart.css';
import { StepContext } from '../../contexts/StepContext';
import { ButtonNext } from '../../contexts/ButtonNext';
import ReviewFormattedMessage from '../../generics/ReviewFormattedMessage';

export default function PageStart ({ slide }) {
  const { setButtonNext } = useContext(ButtonNext);

  useEffect(() => {
    setButtonNext(null)
  }, [setButtonNext])

  // Debug: log accueil values if missing
  if (!slide.accueils) {
    console.warn('[PageStart] Missing accueils object in slide:', slide);
    return <div className="PageStart"><div className="PageStart-content">Aucune information d'accueil trouvée.</div></div>;
  }

  const { accueil1, accueil2, accueil3, accueil18 } = slide.accueils;

  // Debug: Show the actual descriptor objects in the UI
  return (
    <div className="PageStart">
      <div className="PageStart-content">
        <h3 className="PageStart-desc">
          <ReviewFormattedMessage descriptor={accueil1} />
        </h3>
        <h3>
          <ReviewFormattedMessage descriptor={accueil2} />
        </h3>
        <h3>
          <ReviewFormattedMessage descriptor={accueil3} />
        </h3>
        <h3 className="PageStart-attention">
          <ReviewFormattedMessage descriptor={accueil18} />
        </h3>
      </div>
    </div>
  );
}
